
'use strict';

import objectAssign from 'object-assign';
import raf from 'raf';


// quotesTicker(myElement, { timePerQuote: 2000 })
// quotesTicker.start();


function updateQuoteTicker(options, state) {
    const elems = options.rootElem.querySelectorAll(`[${options.targetAttribute}]`);
    const activeClassName = 'is-active';

    let updateLoop = () => {
        raf(() => {
            let currentTime = Date.now();
            let prevIndex;

            if (currentTime - state.timeStamp > options.timePerQuote) {
                state.activeIndex += 1;

                if (state.activeIndex > options.numberOfItems - 1) {
                    state.activeIndex = 0;
                }

                prevIndex = state.activeIndex - 1;

                if (prevIndex < 0) {
                    prevIndex = options.numberOfItems - 1;
                }

                // console.log('show item', state.activeIndex);
                // console.log('hide item', prevIndex);

                elems[state.activeIndex].classList.add(activeClassName);
                elems[prevIndex].classList.remove(activeClassName);

                state.timeStamp = currentTime;
            }

            updateLoop();
        });
    };

    updateLoop();
}

const defaultOptions = {
    timePerQuote: 2000,
    targetAttribute: 'data-quote-item'
};

function quotesTicker(rootElem, userOptions) {
    if (!rootElem) {
        throw new Error('quotesTicker – Please provide a valid root element');
    }

    let options = objectAssign(
        {},
        defaultOptions,
        userOptions
    );

    options.rootElem = rootElem;
    options.numberOfItems = rootElem.querySelectorAll(`[${options.targetAttribute}]`).length

    let state = {
        activeIndex: 0,
        timeStamp: 0
    };

    return objectAssign({}, {
        start: () => {
            state.timeStamp = Date.now();
            updateQuoteTicker(options, state);
        }
    });
}


export default quotesTicker;





/** WEBPACK FOOTER **
 ** ./src/scripts/client/widgets/quotesTicker.js
 **/